import {Box, Button, Typography} from "@mui/material"
import {Trans} from "react-i18next";

import {theme} from "../../../../utils";
import {dataPrivacyLink} from "../../../../assets/data";
import TranslationMsg from '../../transMessage';

import {CommonDialog} from "../../../dialog/CommonDialog";
import {privacyPolicyDialogStyles, IPrivacyPolicyDialogProps} from './privacyPolicyDialog-helpers';

export const PrivacyPolicyDialog = (props: IPrivacyPolicyDialogProps) => {
    const {showPrivacyPolicyDialog, onClosePrivacyPolicyDialog, contentData} = props

    const handleClose = () => {
        if (onClosePrivacyPolicyDialog) {
            onClosePrivacyPolicyDialog()
        }
    };

    const handleContinue = () => {
        window.open(dataPrivacyLink, '_blank', 'noopener,noreferrer');
        handleClose();
    };

    return (
        <CommonDialog
            isDialogVisible={showPrivacyPolicyDialog}
            headerLabel={contentData?.title}
            headerTitleSx={{...privacyPolicyDialogStyles.headerTitleSx, textAlign: 'center'}}
            // headerSubtitle={t(TranslationMsg.DPN_DESCRIPTION)}
            headerSubTitleSx={{...privacyPolicyDialogStyles.headerSubTitleSx, fontWeight: 400, textAlign: 'center'}}
            maxDialogWidth={false}
            slotProps={{paper: {sx: {maxWidth: '818px', width: '818px'}}}}
            onDialogClose={handleClose}>
            <Box textAlign={'center'} sx={{px: "32px"}}>
                <Typography sx={{...privacyPolicyDialogStyles.contentLabel, pr: 0, mt: "30px"}}>
                    <Trans
                        i18nKey={TranslationMsg.DPN_DESCRIPTION}
                        components={{br: <br/>, b: <b></b>}}/>
                </Typography>
                <Box display={"flex"} justifyContent={"center"} gap={2} mt={'52px'} mb="24px">
                    <Button
                        onClick={handleClose}
                        variant={'outlined'}
                        sx={privacyPolicyDialogStyles.cancelButtonWrapper}>
                        <Typography sx={{
                            ...theme.typography.components.montseratButtonContainedLabel,
                            color: "#000"
                        }}>Cancel</Typography>
                    </Button>
                    <Button
                        onClick={handleContinue}
                        variant={'contained'}
                        sx={privacyPolicyDialogStyles.continueButtonWrapper}>
                        <Typography sx={{
                            ...theme.typography.components.montseratButtonContainedLabel,
                            color: "#fff"
                        }}>Continue</Typography>
                    </Button>
                </Box>
            </Box>
        </CommonDialog>
    )
}
